<template>
  <div></div>
</template>

<script>
export default {
  name: "GalleryPhoto"
};
</script>
